import { ITexturedShapeDrawableObject } from "../../../../../../domain/editableFormat/objects";
import { ITexturedShapeDrawableObjectBean } from "../../../beans/objects";
import { AbstractObjectTranslator } from "../AbstractObjectTranslator";
import { ShapeDrawableObjectTranslator } from "./ShapeDrawableObjectTranslator";

export class TexturedShapeDrawableObjectTranslator<TObject extends ITexturedShapeDrawableObject, TBean extends ITexturedShapeDrawableObjectBean> extends AbstractObjectTranslator<TObject, TBean> {
  constructor() {
    super(new ShapeDrawableObjectTranslator());
  }

  overwriteObject(source: TObject, bean: TBean, formatId: number): void {
    source.textureStyle = {
      kind: this.integer.from(bean["@texture"]),
    };
  }

  overwriteBean(source: TBean, object: TObject): void {
    source["@texture"] = this.integer.to(object.textureStyle.kind);
  }
}
